import numeral from 'numeral';

export const yuan = (val: number | string) => `¥ ${numeral(val).format('0,0')}`;

export const addToken = (
  token: string, 
  tokenType: string = 'Bearer', 
  remember: boolean = false // 新增：是否记住登录状态
) => {
  if (!token) return;
  const storage = remember ? localStorage : sessionStorage;
  storage.setItem('token', token);
  storage.setItem('tokenType', tokenType);
};

export const getToken = () => {
  let token = localStorage.getItem('token');
  let tokenType = localStorage.getItem('tokenType') || 'Bearer';

  if (!token) {
    token = sessionStorage.getItem('token');
    tokenType = sessionStorage.getItem('tokenType') || 'Bearer';
  }

  return token ? `${tokenType} ${token}` : '';
};

// 新增：清除所有 Token 相关存储
export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('tokenType');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('tokenType');
};